export const homePath = "/";

export const pairPath = "/pair";

export const disconnectedPath = `/disconnected`;

export default homePath;
